export const AUTOMATION_IDS = {
  NAME_LABEL: 'site-segment-name-label',
};
